import SectionHero from '@/components/SectionHero';
import DefaultSolutionTemplate from '@/components/templates/Solution';
import { sdk } from '@/lib/graphcms';

export default function ContentFederation({ solution }) {
  return (
    <DefaultSolutionTemplate page={solution}>
      <SectionHero
        title="Mission critical content management, on your terms"
        description="Time matters when delivering content at an ambitious scale. GraphCMS provides you with central control of your enterprise content from multiple sources through a unified content layer."
      />
    </DefaultSolutionTemplate>
  );
}

export const getStaticProps = async ({ preview = false }) => {
  const { solution } = await sdk({ preview }).useCasePage({
    slug: 'content-federation',
  });

  if (!solution) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      preview,
      solution,
    },
    revalidate: 3600,
  };
};
